import { Button, Grid, TextField } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import queryString from 'query-string'

import { useTitle } from 'hooks'

import LoginSidePanel from 'components/LoginSidePanel'

import { confirmPasswordReset, redirectTo } from 'store/actions/user'

const PasswordResetPage = () => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)
  const { search } = useLocation()
  const { token } = queryString.parse(search)
  const dispatch = useDispatch()

  const [password, setPassword] = useState('')
  const [passwordRepeat, setPasswordRepeat] = useState('')
  const [passwordValid, setPasswordValid] = useState(false)
  const [passwordError, setPasswordError] = useState('')
  const [passwordRepeatError, setPasswordRepeatError] = useState('')

  const [errorMessage, setErrorMessage] = useState('')
  const [successMessage, setSuccessMessage] = useState('')

  useTitle(t => t.user.resetPasswordMainTitle)

  const handlePasswordChange = e => {
    setErrorMessage('')
    validatePassword(e.target.value, passwordRepeat)
    setPassword(e.target.value)
  }

  const handleRepeatChange = e => {
    setErrorMessage('')
    validatePassword(password, e.target.value)
    setPasswordRepeat(e.target.value)
  }

  const submitNewPassword = async () => {
    const { success, err } = await dispatch(confirmPasswordReset(password, token))

    if (!success) {
      setSuccessMessage('')
      setErrorMessage(err)
    } else {
      setErrorMessage('')
      setSuccessMessage(t.user.updatePasswordSuccess)
      await new Promise(resolve => setTimeout(resolve, 3000))
      dispatch(redirectTo('/login'))
    }
  }

  const validatePassword = (pass, repeat) => {
    const empty = ''
    let isValid = true

    if (pass === empty) {
      setPasswordError(t.user.fieldRequired)
      isValid = false
    }
    if (repeat === empty) {
      setPasswordRepeatError(t.user.fieldRequired)
      isValid = false
    }
    if (pass !== repeat) {
      setPasswordRepeatError(t.user.updatePasswordError)
      isValid = false
    }
    if (isValid) {
      setPasswordError(empty)
      setPasswordRepeatError(empty)
    }
    setPasswordValid(isValid)
  }

  return (
    <div>
      <Grid container>
        <LoginSidePanel />
        <Grid size={{ xs: 12, md: 9 }}>
          <div className="password_reset_dialog">
            <b>{t.user.resetPasswordText}</b>
            <h3>{t.user.resetPasswordTitle}</h3>
            <form className="Login">
              <TextField
                label={t.user.updatePassword}
                variant="standard"
                type="password"
                onChange={handlePasswordChange}
                error={!!passwordError}
                helperText={passwordError}
                disabled={!!successMessage}
              />
              <TextField
                label={t.user.updatePasswordRepeat}
                variant="standard"
                type="password"
                onChange={handleRepeatChange}
                error={!!passwordRepeatError}
                helperText={passwordRepeatError}
                disabled={!!successMessage}
              />
              {!!successMessage ? (
                <div className="message-success">{successMessage}</div>
              ) : (
                <Button disabled={!passwordValid} onClick={submitNewPassword} variant="text">
                  {t.user.updatePasswordSubmit}
                </Button>
              )}
            </form>

            {!!errorMessage && <div className="message-danger">{errorMessage}</div>}
          </div>
        </Grid>
      </Grid>
    </div>
  )
}

export default PasswordResetPage
